import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/app/slw/widgets/common/breadcrumb.ui.tsx");
